import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import { ContactForm } from '../views/contact-form';
import { BlogPostPreview } from '../components/blog-post-preview';
import { HTMLContent } from '../components/Content';

export default ({ data }) => {
  const { tag, posts } = data;

  const title = tag.title;

  return (
    <Layout title={title}>
      <section className="section">
        <div className="container">
          <h1 className="title is-1 has-text-centered">{title}</h1>
          <HTMLContent content={tag.description} />
          <div style={{ marginTop: '2rem' }}>
            {posts.edges.map(({ node: post }) => (
              <div style={{ marginBottom: '1rem' }} key={post.id}>
                <BlogPostPreview
                  title={post.title}
                  content={post.intro}
                  href={`/blog/${post.slug}/`}
                />
                <hr />
              </div>
            ))}
          </div>
          <ContactForm />
        </div>
      </section>
    </Layout>
  );
};

/**
 * id — contentful_id тега
 */
export const blogTagPageQuery = graphql`
  query blogTagPageQuery($id: String!) {
    tag: contentfulBlogPostTag(contentful_id: { eq: $id }) {
      title
      description {
        childMarkdownRemark {
          html
        }
      }
    }

    posts: allContentfulBlogPost(
      filter: { tags: { elemMatch: { contentful_id: { eq: $id } } } }
      sort: { fields: [date], order: DESC }
    ) {
      edges {
        node {
          id
          title
          intro {
            childMarkdownRemark {
              html
            }
          }
          slug
        }
      }
    }
  }
`;
